import axiosInstance from "../dev_axiosInstance";

export const DEVLOPERLOGIN = async (data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/onboarding/v1/login`;

  const response = await axiosInstance.post(urls, data);
  return response.data;
};
export const FORGETPASSWORDAPI = async (data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/onboarding/v1/forgot/password`;

  const response = await axiosInstance.post(urls, data);
  return response;
};
export const UPDATEPASSWORDAPI = async (data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/onboarding/v1/update/password`;

  const response = await axiosInstance.post(urls, data);
  return response;
};

export const DEVLOPERSIGNUP = async (data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/onboarding/v1/signup?app_id=1`;

  const response = await axiosInstance.post(urls, data);
  return response.data;
};
export const CREATENEWAPP = async (data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/`;
  const response = await axiosInstance.post(urls, data);
  return response.data;
};

export const DEVLOPERALLAPPS = async (pageNumber) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/apps?page=${pageNumber}&limit=10`;

  const response = await axiosInstance.get(urls, {});
  return response;
};

export const DEVLOPERALLAPPSSEARCH = async (pageNumber, searchKey) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/apps?page=${pageNumber}&limit=10&search=${searchKey}`;

  const response = await axiosInstance.get(urls, {});
  return response.data;
};

///get app overview Deatils Api
export const GETAPPOVERVIEWDETAILS = async (app_id) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/?app_id=${app_id}`;
  const response = await axiosInstance.get(urls);
  return response.data;
};
export const SAVECONFIGURATIONSAPI = async (data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/`;
  const response = await axiosInstance.put(urls, data);
  return response.data;
};

export const UPLOADBANNERAPI = async (appid, data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${appid}/upload-banner`;
  const response = await axiosInstance.post(urls, data);
  return response.data;
};

export const ACTIVEPLANAPI = async (appid, data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${appid}/plan/activate`;
  const response = await axiosInstance.post(urls, data);
  return response;
};
export const EDITPLANAPI = async (appid, data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${appid}/plan`;
  const response = await axiosInstance.put(urls, data);
  return response;
};

export const ADDPLANAPI = async (appid, data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${appid}/plan`;
  const response = await axiosInstance.post(urls, data);
  return response;
};
export const SUBMITAPP = async (appid, data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${appid}/submit`;
  const response = await axiosInstance.post(urls, data);
  return response;
};

export const UPLOADIMAGEAPI = async (files: File[]) => {
  const formData = new FormData();
  formData.append("file", files[0], "file.png"); // Assuming only one file is uploaded and filename is file.png

  try {
    const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/upload`;
    // Make the POST request with axiosInstance, which already has the correct interceptors set up
    const response = await axiosInstance.post(urls, formData);
    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error; // Re-throw the error to handle it in the calling code
  }
};
export const REMOBEBANNERAPI = async (app_id, formData) => {
  // Assuming only one file is uploaded and filename is file.png

  try {
    const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${app_id}/upload-banner`;
    // Make the POST request with axiosInstance, which already has the correct interceptors set up
    const response = await axiosInstance.post(urls, formData);
    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error; // Re-throw the error to handle it in the calling code
  }
};

///get app overview Deatils Api
export const GETAPPPERMISSIONDETAILS = async () => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/permissions`;
  const response = await axiosInstance.get(urls);
  return response.data;
};

export const REQUESTACCESS = async (data, app_id) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${app_id}/permissions`;
  const response = await axiosInstance.put(urls, data);
  return response.data;
};

export const GETPERMISSIONSTATUS = async (status, app_id) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/${app_id}/permissions?status=${status}`;
  const response = await axiosInstance.get(urls);
  return response.data;
};

export const GETLISTOFCATEGORY = async () => {
  const urls = `${process.env.REACT_APP_BASE_URL}/developer/v1/app/category`;
  const response = await axiosInstance.get(urls);
  return response.data;
};

export const UPDATEPASSWORD = async (data) => {
  const urls = `${process.env.REACT_APP_BASE_URL}/onboarding/v1/update/password`;

  const response = await axiosInstance.post(urls, data);
  return response.data;
};
